import { render, staticRenderFns } from "./Medicine.vue?vue&type=template&id=70b241b8&"
import script from "./Medicine.vue?vue&type=script&lang=js&"
export * from "./Medicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports